import React from 'react'

export default function RenderType({ item }) {
    return (
        <>
            <strong>{item.service}</strong>
            <div>{item.subservice}</div>
        </>
    )
}
